import { GoogleMap } from '@capacitor/google-maps';
import { PreserveStringAlias } from 'src/app/utils/alias.utils';
import { PolylineConfig } from './polyline.config';
import { Polyline as GoogleMapPolyline } from '@capacitor/google-maps';
import { MSLatLng } from 'src/app/models/map.model';
import { msLatLngToLatLng } from 'src/app/utils/google-map/google-map.utils';

type PolylineId = string & PreserveStringAlias;

export class Polyline {
  private config: PolylineConfig;
  private polylineId: PolylineId | null = null;

  private constructor(private map: GoogleMap) {}

  static async create(map: GoogleMap, config: PolylineConfig): Promise<Polyline> {
    const polyline = new Polyline(map);
    await polyline.add(config);

    return polyline;
  }

  async update(updateOpts: Partial<PolylineConfig>): Promise<void> {
    if (!this.polylineId) {
      return;
    }

    const opts = { ...this.config, ...updateOpts };

    await this.remove();
    await this.add(opts);
  }

  async remove(): Promise<void> {
    if (!this.polylineId) {
      return;
    }

    await this.map.removePolylines([this.polylineId]);
    this.polylineId = null;
  }

  private async add(config: PolylineConfig): Promise<void> {
    const markerConfig: GoogleMapPolyline = this.convertPolylineConfigToGoogleMapPolyline(config);
    const id = await this.map.addPolylines([markerConfig])[0];

    this.config = config;
    this.polylineId = id;
  }

  private convertPolylineConfigToGoogleMapPolyline(config: PolylineConfig): GoogleMapPolyline {
    const path = config.path.map((point: MSLatLng) => msLatLngToLatLng(point));

    return {
      path,
      strokeWeight: config.width,
      strokeColor: config.color,
      geodesic: config.geodesic
    };
  }
}
